import { ProcessParameter, TimelineBatch } from "../../../types/mes";
import { extractClockTime } from "../../../utils/processParameterSerialize";

/** Convert DB/API time value to ISO datetime on production date for Gantt (wall-clock, no TZ shift). */
export function paramTimeToIso(productionDate: string, value: unknown): string | undefined {
  const clock = extractClockTime(value);
  if (!clock) return undefined;
  const [hh, mm] = clock.split(":");
  // Local wall-clock on production day (no Z) — matches Gantt/planning time axis
  return `${productionDate}T${hh}:${mm}:00`;
}

export function buildActualBatches(
  planned: TimelineBatch[],
  params: ProcessParameter[],
  productionDate: string
): TimelineBatch[] {
  const byZamjesa = new Map(params.map((p) => [p.MixCode, p]));

  return planned.map((batch) => {
    const p = byZamjesa.get(batch.MixCode);
    if (!p) return { ...batch };

    const raw = p as unknown as Record<string, unknown>;
    const t = (key: string) => paramTimeToIso(productionDate, raw[key]);

    const startObrada = t("FinalProofStart");
    const endObrada = t("FinalProofEnd");

    return {
      ...batch,
      MixingStart: t("MixingStart"),
      MixingEnd: t("MixingEnd") ?? t("BulkFermentationEnd"),
      ProcessingStart: startObrada,
      ProcessingEnd: endObrada,
      FinalProofStart: startObrada,
      FinalProofEnd: endObrada,
      BakingStart: t("BakingStart"),
      BakingEnd: t("BakingEnd"),
      FermentationStart: undefined,
      FermentationEnd: undefined,
    };
  });
}

export function countBatchesWithActual(params: ProcessParameter[]): number {
  return params.length;
}
